// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PCEtLSBUaGlzIGljb24gaXMgcGFydCBvZiBNYXRlcmlhbCBVSSBJY29ucy4gQ29weXJpZ2h0IDIwMjAgR29vZ2xlIEluYy4sIEFwYWNoZS0yLjAgTGljZW5zZSAtLT4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTQuOCAxMS4yaDYuNFY0LjhINC44djYuNHpNOCAwQzMuNiAwIDAgMy42IDAgOHMzLjYgOCA4IDggOC0zLjYgOC04LTMuNi04LTgtOHoiIGZpbGw9IiM0OWIzODIiLz48L3N2Zz4K", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PCEtLSBUaGlzIGljb24gaXMgcGFydCBvZiBNYXRlcmlhbCBVSSBJY29ucy4gQ29weXJpZ2h0IDIwMjAgR29vZ2xlIEluYy4sIEFwYWNoZS0yLjAgTGljZW5zZSAtLT4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTS00LTRoMjR2MjRILTRWLTR6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTggMEMzLjYgMCAwIDMuNiAwIDhzMy42IDggOCA4IDgtMy42IDgtOC0zLjYtOC04LTh6IiBmaWxsPSIjZWQ0ODRjIi8+PHBhdGggZD0iTTUgNi41aDZjLjggMCAxLjUuNyAxLjUgMS41cy0uNyAxLjUtMS41IDEuNUg1Yy0uOCAwLTEuNS0uNy0xLjUtMS41UzQuMiA2LjUgNSA2LjV6IiBmaWxsPSIjZmRmZmZmIi8+PC9zdmc+Cg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;base64,PCEtLSBUaGlzIGljb24gaXMgcGFydCBvZiBNYXRlcmlhbCBVSSBJY29ucy4gQ29weXJpZ2h0IDIwMjAgR29vZ2xlIEluYy4sIEFwYWNoZS0yLjAgTGljZW5zZSAtLT4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTS00LTRoMjR2MjRILTR6Ii8+PHBhdGggZD0iTTYuOS4xQzMgLjYtLjEgNC0uMSA4YzAgNC40IDMuNiA4IDggOCA0IDAgNy40LTMgOC02LjktMS4yIDEuMy0yLjkgMi4xLTQuNyAyLjEtMy41IDAtNi40LTIuOS02LjQtNi40IDAtMS45LjgtMy42IDIuMS00Ljd6IiBmaWxsPSIjZjRhMzMxIi8+PC9zdmc+Cg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.material-design-icon[data-v-25cf09d8] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.autocomplete-result[data-v-25cf09d8] {
  display: flex;
  height: 44px;
  padding: 10px;
}
.highlight .autocomplete-result[data-v-25cf09d8] {
  color: var(--color-primary-element-light-text);
  background: var(--color-primary-element-light);
}
.highlight .autocomplete-result[data-v-25cf09d8],
.highlight .autocomplete-result *[data-v-25cf09d8] {
  cursor: pointer;
}
.autocomplete-result__icon[data-v-25cf09d8] {
  position: relative;
  flex: 0 0 44px;
  width: 44px;
  min-width: 44px;
  height: 44px;
  border-radius: 44px;
  background-color: var(--color-background-darker);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 24px;
}
.autocomplete-result__icon--with-avatar[data-v-25cf09d8] {
  color: inherit;
  background-size: cover;
}
.autocomplete-result__status[data-v-25cf09d8] {
  position: absolute;
  right: -4px;
  bottom: -4px;
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  border: 2px solid var(--color-main-background);
  border-radius: 50%;
  background-color: var(--color-main-background);
  font-size: var(--default-font-size);
  line-height: 15px;
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: center;
}
.autocomplete-result__status--online[data-v-25cf09d8] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.autocomplete-result__status--dnd[data-v-25cf09d8] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-color: #fff;
}
.autocomplete-result__status--away[data-v-25cf09d8] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.autocomplete-result__status--icon[data-v-25cf09d8] {
  border: none;
  background-color: transparent;
}
.autocomplete-result__content[data-v-25cf09d8] {
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding-left: 10px;
}
.autocomplete-result__title[data-v-25cf09d8],
.autocomplete-result__subline[data-v-25cf09d8] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.autocomplete-result__subline[data-v-25cf09d8] {
  color: var(--color-text-maxcontrast);
}
.material-design-icon[data-v-9e395f41] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.rich-contenteditable__input[data-v-9e395f41] {
  overflow-y: auto;
  width: auto;
  margin: 0;
  padding: 8px;
  cursor: text;
  white-space: pre-wrap;
  word-break: break-word;
  color: var(--color-main-text);
  border: 2px solid var(--color-border-dark);
  border-radius: var(--border-radius-large);
  outline: none;
  background-color: var(--color-main-background);
  font-family: var(--font-face);
  font-size: inherit;
  min-height: 44px;
  max-height: 242px;
}
.rich-contenteditable__input--empty[data-v-9e395f41]:before {
  content: attr(aria-placeholder);
  color: var(--color-text-maxcontrast);
  position: absolute;
}
.rich-contenteditable__input[contenteditable=false][data-v-9e395f41]:not(.rich-contenteditable__input--disabled) {
  cursor: default;
  background-color: transparent;
  color: var(--color-main-text);
  border-color: transparent;
  opacity: 1;
  border-radius: 0;
}
.rich-contenteditable__input--multiline[data-v-9e395f41] {
  min-height: 132px;
  max-height: none;
}
.rich-contenteditable__input--disabled[data-v-9e395f41] {
  opacity: .5;
  color: var(--color-text-maxcontrast);
  border: 2px solid var(--color-background-darker);
  border-radius: var(--border-radius);
  background-color: var(--color-background-dark);
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.tribute-container,
.tribute-container-emoji,
.tribute-container-link {
  z-index: 9000;
  overflow: auto;
  min-width: 250px;
  max-width: 300px;
  max-height: 288px;
  margin: 5px 0;
  color: var(--color-main-text);
  border-radius: var(--border-radius);
  background: var(--color-main-background);
  box-shadow: 0 1px 5px var(--color-box-shadow);
}
.tribute-container-emoji,
.tribute-container-link {
  min-width: 200px;
  max-width: 200px;
  padding: 4px;
  max-height: 192.5px !important;
}
.tribute-container-emoji__item,
.tribute-container-link__item {
  border-radius: 8px;
  padding: 4px 8px;
  margin-bottom: 4px;
  opacity: .8;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tribute-container-emoji__item:last-child,
.tribute-container-link__item:last-child {
  margin-bottom: 0;
}
.tribute-container-emoji__item__emoji,
.tribute-container-link__item__emoji {
  padding-right: 8px;
}
.tribute-container-emoji .highlight,
.tribute-container-link .highlight {
  opacity: 1;
  color: var(--color-primary-element-light-text);
  background: var(--color-primary-element-light);
}
.tribute-container-emoji .highlight,
.tribute-container-emoji .highlight *,
.tribute-container-link .highlight,
.tribute-container-link .highlight * {
  cursor: pointer;
}
.tribute-container-link {
  min-width: 200px;
  max-width: 300px;
}
.tribute-container-link__item {
  display: flex;
  align-items: center;
}
.tribute-container-link__item__title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tribute-container-link__item__icon {
  margin: auto 0;
  width: 20px;
  height: 20px;
  object-fit: contain;
  padding-right: 8px;
  filter: var(--background-invert-if-dark);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-ffa6d11c.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;AACf;AACA;EACE,8CAA8C;EAC9C,8CAA8C;AAChD;AACA;;EAEE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,8CAA8C;EAC9C,mCAAmC;EACnC,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,yDAAqZ;AACvZ;AACA;EACE,yDAA6jB;EAC7jB,sBAAsB;AACxB;AACA;EACE,yDAAqgB;AACvgB;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,0CAA0C;EAC1C,yCAAyC;EACzC,aAAa;EACb,8CAA8C;EAC9C,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,gDAAgD;EAChD,mCAAmC;EACnC,8CAA8C;AAChD;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;EAGE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,mCAAmC;EACnC,wCAAwC;EACxC,6CAA6C;AAC/C;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;AAChC;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,UAAU;EACV,8CAA8C;EAC9C,8CAA8C;AAChD;AACA;;;;EAIE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C","sourcesContent":["@charset \"UTF-8\";\n.material-design-icon[data-v-25cf09d8] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.autocomplete-result[data-v-25cf09d8] {\n  display: flex;\n  height: 44px;\n  padding: 10px;\n}\n.highlight .autocomplete-result[data-v-25cf09d8] {\n  color: var(--color-primary-element-light-text);\n  background: var(--color-primary-element-light);\n}\n.highlight .autocomplete-result[data-v-25cf09d8],\n.highlight .autocomplete-result *[data-v-25cf09d8] {\n  cursor: pointer;\n}\n.autocomplete-result__icon[data-v-25cf09d8] {\n  position: relative;\n  flex: 0 0 44px;\n  width: 44px;\n  min-width: 44px;\n  height: 44px;\n  border-radius: 44px;\n  background-color: var(--color-background-darker);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 24px;\n}\n.autocomplete-result__icon--with-avatar[data-v-25cf09d8] {\n  color: inherit;\n  background-size: cover;\n}\n.autocomplete-result__status[data-v-25cf09d8] {\n  position: absolute;\n  right: -4px;\n  bottom: -4px;\n  box-sizing: border-box;\n  width: 18px;\n  height: 18px;\n  border: 2px solid var(--color-main-background);\n  border-radius: 50%;\n  background-color: var(--color-main-background);\n  font-size: var(--default-font-size);\n  line-height: 15px;\n  background-repeat: no-repeat;\n  background-size: 16px;\n  background-position: center;\n}\n.autocomplete-result__status--online[data-v-25cf09d8] {\n  background-image: url(data:image/svg+xml;base64,PCEtLSBUaGlzIGljb24gaXMgcGFydCBvZiBNYXRlcmlhbCBVSSBJY29ucy4gQ29weXJpZ2h0IDIwMjAgR29vZ2xlIEluYy4sIEFwYWNoZS0yLjAgTGljZW5zZSAtLT4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTQuOCAxMS4yaDYuNFY0LjhINC44djYuNHpNOCAwQzMuNiAwIDAgMy42IDAgOHMzLjYgOCA4IDggOC0zLjYgOC04LTMuNi04LTgtOHoiIGZpbGw9IiM0OWIzODIiLz48L3N2Zz4K);\n}\n.autocomplete-result__status--dnd[data-v-25cf09d8] {\n  background-image: url(data:image/svg+xml;base64,PCEtLSBUaGlzIGljb24gaXMgcGFydCBvZiBNYXRlcmlhbCBVSSBJY29ucy4gQ29weXJpZ2h0IDIwMjAgR29vZ2xlIEluYy4sIEFwYWNoZS0yLjAgTGljZW5zZSAtLT4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTS00LTRoMjR2MjRILTRWLTR6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTggMEMzLjYgMCAwIDMuNiAwIDhzMy42IDggOCA4IDgtMy42IDgtOC0zLjYtOC04LTh6IiBmaWxsPSIjZWQ0ODRjIi8+PHBhdGggZD0iTTUgNi41aDZjLjggMCAxLjUuNyAxLjUgMS41cy0uNyAxLjUtMS41IDEuNUg1Yy0uOCAwLTEuNS0uNy0xLjUtMS41UzQuMiA2LjUgNSA2LjV6IiBmaWxsPSIjZmRmZmZmIi8+PC9zdmc+Cg==);\n  background-color: #fff;\n}\n.autocomplete-result__status--away[data-v-25cf09d8] {\n  background-image: url(data:image/svg+xml;base64,PCEtLSBUaGlzIGljb24gaXMgcGFydCBvZiBNYXRlcmlhbCBVSSBJY29ucy4gQ29weXJpZ2h0IDIwMjAgR29vZ2xlIEluYy4sIEFwYWNoZS0yLjAgTGljZW5zZSAtLT4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTS00LTRoMjR2MjRILTR6Ii8+PHBhdGggZD0iTTYuOS4xQzMgLjYtLjEgNC0uMSA4YzAgNC40IDMuNiA4IDggOCA0IDAgNy40LTMgOC02LjktMS4yIDEuMy0yLjkgMi4xLTQuNyAyLjEtMy41IDAtNi40LTIuOS02LjQtNi40IDAtMS45LjgtMy42IDIuMS00Ljd6IiBmaWxsPSIjZjRhMzMxIi8+PC9zdmc+Cg==);\n}\n.autocomplete-result__status--icon[data-v-25cf09d8] {\n  border: none;\n  background-color: transparent;\n}\n.autocomplete-result__content[data-v-25cf09d8] {\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n  padding-left: 10px;\n}\n.autocomplete-result__title[data-v-25cf09d8],\n.autocomplete-result__subline[data-v-25cf09d8] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.autocomplete-result__subline[data-v-25cf09d8] {\n  color: var(--color-text-maxcontrast);\n}\n.material-design-icon[data-v-9e395f41] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.rich-contenteditable__input[data-v-9e395f41] {\n  overflow-y: auto;\n  width: auto;\n  margin: 0;\n  padding: 8px;\n  cursor: text;\n  white-space: pre-wrap;\n  word-break: break-word;\n  color: var(--color-main-text);\n  border: 2px solid var(--color-border-dark);\n  border-radius: var(--border-radius-large);\n  outline: none;\n  background-color: var(--color-main-background);\n  font-family: var(--font-face);\n  font-size: inherit;\n  min-height: 44px;\n  max-height: 242px;\n}\n.rich-contenteditable__input--empty[data-v-9e395f41]:before {\n  content: attr(aria-placeholder);\n  color: var(--color-text-maxcontrast);\n  position: absolute;\n}\n.rich-contenteditable__input[contenteditable=false][data-v-9e395f41]:not(.rich-contenteditable__input--disabled) {\n  cursor: default;\n  background-color: transparent;\n  color: var(--color-main-text);\n  border-color: transparent;\n  opacity: 1;\n  border-radius: 0;\n}\n.rich-contenteditable__input--multiline[data-v-9e395f41] {\n  min-height: 132px;\n  max-height: none;\n}\n.rich-contenteditable__input--disabled[data-v-9e395f41] {\n  opacity: .5;\n  color: var(--color-text-maxcontrast);\n  border: 2px solid var(--color-background-darker);\n  border-radius: var(--border-radius);\n  background-color: var(--color-background-dark);\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.tribute-container,\n.tribute-container-emoji,\n.tribute-container-link {\n  z-index: 9000;\n  overflow: auto;\n  min-width: 250px;\n  max-width: 300px;\n  max-height: 288px;\n  margin: 5px 0;\n  color: var(--color-main-text);\n  border-radius: var(--border-radius);\n  background: var(--color-main-background);\n  box-shadow: 0 1px 5px var(--color-box-shadow);\n}\n.tribute-container-emoji,\n.tribute-container-link {\n  min-width: 200px;\n  max-width: 200px;\n  padding: 4px;\n  max-height: 192.5px !important;\n}\n.tribute-container-emoji__item,\n.tribute-container-link__item {\n  border-radius: 8px;\n  padding: 4px 8px;\n  margin-bottom: 4px;\n  opacity: .8;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.tribute-container-emoji__item:last-child,\n.tribute-container-link__item:last-child {\n  margin-bottom: 0;\n}\n.tribute-container-emoji__item__emoji,\n.tribute-container-link__item__emoji {\n  padding-right: 8px;\n}\n.tribute-container-emoji .highlight,\n.tribute-container-link .highlight {\n  opacity: 1;\n  color: var(--color-primary-element-light-text);\n  background: var(--color-primary-element-light);\n}\n.tribute-container-emoji .highlight,\n.tribute-container-emoji .highlight *,\n.tribute-container-link .highlight,\n.tribute-container-link .highlight * {\n  cursor: pointer;\n}\n.tribute-container-link {\n  min-width: 200px;\n  max-width: 300px;\n}\n.tribute-container-link__item {\n  display: flex;\n  align-items: center;\n}\n.tribute-container-link__item__title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.tribute-container-link__item__icon {\n  margin: auto 0;\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n  padding-right: 8px;\n  filter: var(--background-invert-if-dark);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
